var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGcpOnwork(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 486,
    height: 150,
    viewBox: "0 0 486 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7529_6275)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.20508 66.9272C9.86675 64.5714 16.2762 59.9111 24.7834 55.509C46.7501 44.1422 71.6484 31.2592 95.8419 46.1991C99.7508 48.6132 102.503 51.37 104.253 54.6276C105.877 57.6494 106.585 61.0905 106.359 64.8558C105.861 73.1571 101.713 80.5237 98.2026 87.835C96.1787 92.0507 94.6664 96.844 95.8632 101.364C97.2494 106.599 102.081 110.358 107.252 111.965C118.437 115.441 131.591 113.974 142.272 110.081",
    stroke: "#3D4451",
    strokeWidth: 2.91207,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.533 115.661C133.215 120.759 120.319 122.232 108.13 119.924C97.9684 118 88.6013 110.352 88.5663 99.2522C88.5488 93.6727 90.5048 88.2805 92.7616 83.1766C95.6669 76.6089 100.746 68.855 98.7761 61.3875C97.5967 56.9146 93.942 53.4239 89.8107 51.3438C68.7972 40.7632 46.2374 52.7561 27.4875 62.4582C18.9677 66.8661 10.9207 71.0304 3.05713 73.6095",
    stroke: "#3D4451",
    strokeWidth: 2.91207,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.759 38.6374C372.594 36.3825 380.957 32.127 389.515 28.9101C398.936 25.369 408.338 21.6639 418.25 19.5808C427.703 17.5948 438.354 17.5035 447.903 19.7419C456.901 21.8512 465.615 26.8853 470.171 34.8255C476.596 46.0244 472.289 57.465 465.562 67.0942C462.303 71.7584 459.488 75.7868 460.092 80.9207C460.641 85.5907 464.393 89.1124 468.531 91.0654C473.969 93.631 479.092 95.4287 485.024 96.38",
    stroke: "#3D4451",
    strokeWidth: 2.8781,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484.231 103.581C471.225 101.172 454.164 97.8418 452.404 81.576C451.529 73.4833 455.665 67.4883 459.314 62.2C461.204 59.4607 462.989 56.8738 464.115 54.0918C466.528 48.1298 466.611 42.1542 464.341 37.6987C462.16 33.4161 458.005 30.7234 454.905 29.2178C436.802 20.4321 416.725 25.9602 399.038 32.9191C387.994 37.2639 377.036 41.8397 366.04 46.3059",
    stroke: "#3D4451",
    strokeWidth: 2.91207,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.292 111.601L161.295 117.366C162.311 120.287 165.395 121.87 168.184 120.901L180.708 116.547L178.331 110.04C178.331 110.04 165.242 118.077 159.292 111.601Z",
    fill: "#C7DDEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.632 108.807L179.719 112.087C181.589 117.738 187.47 120.727 192.853 118.763L219.738 108.954L215.386 95.8082L178.632 108.808V108.807Z",
    fill: "#C7DDEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.92 109.766L156.022 106.951L159.432 116.765L151.33 119.58C148.683 120.5 145.788 119.097 144.868 116.451L144.791 116.228C143.871 113.581 145.274 110.686 147.92 109.767L147.92 109.766Z",
    fill: "#C7DDEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.217 111.021L190.596 118.883C186.066 120.457 181.119 118.061 179.544 113.532L170.926 88.7348C169.351 84.2055 171.747 79.2579 176.276 77.6835L198.897 69.8218L213.216 111.021H213.217Z",
    stroke: "#3D4451",
    strokeWidth: 3.27803,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.709 116.547L168.184 120.901C165.395 121.869 162.311 120.287 161.296 117.366L154.261 97.1245C153.246 94.2037 154.684 91.0499 157.472 90.0802L169.997 85.7266",
    stroke: "#3D4451",
    strokeWidth: 3.27803,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.044 65.4431L201.165 65.7488C199.351 66.3798 198.391 68.3619 199.021 70.1761L213.094 110.668C213.725 112.482 215.707 113.442 217.521 112.811L218.4 112.505C220.215 111.874 221.175 109.892 220.544 108.078L206.472 67.5863C205.841 65.7721 203.858 64.8121 202.044 65.4431Z",
    stroke: "#3D4451",
    strokeWidth: 2.78297,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.872 95.419C166.331 95.2598 166.832 95.5025 166.992 95.9616L171.922 110.145C172.081 110.604 171.838 111.105 171.379 111.266C170.92 111.425 170.419 111.182 170.259 110.723L165.33 96.5392C165.17 96.08 165.413 95.5791 165.872 95.419Z",
    fill: "#3D4451"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.717 96.8634C162.176 96.7042 162.677 96.9468 162.837 97.406L167.766 111.59C167.925 112.049 167.683 112.55 167.224 112.71C166.765 112.869 166.264 112.626 166.104 112.167L161.174 97.9835C161.015 97.5244 161.258 97.0235 161.717 96.8634Z",
    fill: "#3D4451"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.402 104.86L155.691 101.633L159.601 112.885L150.312 116.113C147.277 117.167 143.957 115.559 142.903 112.524L142.814 112.268C141.76 109.233 143.368 105.915 146.402 104.86Z",
    stroke: "#3D4451",
    strokeWidth: 2.45876,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.258 52.3077L352.058 56.0817L349.222 47.6629L360.422 43.8889C362.746 43.1055 365.266 44.3548 366.05 46.6806C366.833 49.0054 365.584 51.5253 363.258 52.3087V52.3077Z",
    fill: "#C7DDEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.371 56.1371L335.261 62.2515L336.833 73.8706L349.948 68.8036C353.224 67.5378 355.364 62.7009 354.728 57.9998C354.539 56.6001 353.461 55.7488 352.372 56.138L352.371 56.1371Z",
    fill: "#C7DDEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.964 67.7456L329.652 75.7218C330.324 77.7185 332.532 78.7765 334.582 78.0864L334.645 78.065C336.695 77.3739 337.812 75.1956 337.14 73.1989L334.473 65.2849",
    fill: "#C7DDEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.91 76.011L297.125 88.2854C295.135 88.9562 293.108 88.2709 292.598 86.7546L290.938 81.8284C290.427 80.3131 291.626 78.5406 293.616 77.8699L327.061 66.6011",
    fill: "#C7DDEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.653 61.4531L289.252 67.653L290.377 70.9931L308.779 64.7932L307.653 61.4531Z",
    fill: "#FDC345"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.532 35.3633L338.143 31.1146C341.293 30.0536 344.707 31.7465 345.769 34.8964L354.063 59.5112C355.124 62.6611 353.431 66.075 350.281 67.137L337.67 71.3857",
    stroke: "#3D4451",
    strokeWidth: 3.60612,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.032 49.0607L351.933 52.7998L348.161 41.6058L359.26 37.8667C362.352 36.8252 365.702 38.487 366.743 41.5777C367.785 44.6693 366.123 48.0192 363.032 49.0607Z",
    stroke: "#3D4451",
    strokeWidth: 3.03147,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.413 76.5507L295.653 88.2621L281.843 47.2747L316.604 35.5623",
    stroke: "#3D4451",
    strokeWidth: 3.32656,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.548 58.1708L288.146 64.3706L290.377 70.9919L308.779 64.7921L306.548 58.1708Z",
    stroke: "#3D4451",
    strokeWidth: 2.35587,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.814 58.744L283.122 53.2496L284.888 58.491L268.58 63.9855C267.243 64.4362 265.79 63.7158 265.34 62.3783L265.207 61.9837C264.756 60.6462 265.477 59.1938 266.814 58.7431L266.814 58.744Z",
    stroke: "#3D4451",
    strokeWidth: 2.51506,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.836 82.5484L291.144 77.0539L292.91 82.2954L276.602 87.7899C275.264 88.2405 273.812 87.5202 273.361 86.1827L273.228 85.788C272.778 84.4505 273.498 82.9981 274.836 82.5475L274.836 82.5484Z",
    stroke: "#3D4451",
    strokeWidth: 2.51506,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.049 49.9023L305.762 44.6072",
    stroke: "#3D4451",
    strokeWidth: 1.66377,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.582 78.0864L334.645 78.065C336.695 77.3739 337.798 75.152 337.107 73.1019L324.099 34.4945C323.408 32.4444 321.186 31.3417 319.136 32.0329L319.073 32.0542C317.023 32.7453 315.92 34.9673 316.611 37.0174L329.619 75.6247C330.31 77.6748 332.532 78.7775 334.582 78.0864Z",
    stroke: "#3D4451",
    strokeWidth: 2.74997,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.943 43.5841L311.37 42.8075",
    stroke: "#3D4451",
    strokeWidth: 1.66377,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.939 41.1525C338.399 40.9962 338.899 41.2428 339.055 41.7029L343.887 55.9206C344.043 56.3807 343.796 56.8806 343.336 57.0369C342.876 57.1932 342.376 56.9466 342.22 56.4865L337.389 42.2688C337.232 41.8087 337.479 41.3088 337.939 41.1525Z",
    fill: "#3D4451"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.774 42.5678C334.234 42.4115 334.734 42.6581 334.89 43.1182L339.722 57.3359C339.878 57.796 339.631 58.2959 339.171 58.4522C338.711 58.6085 338.211 58.3619 338.055 57.9018L333.224 43.6841C333.067 43.224 333.314 42.7241 333.774 42.5678Z",
    fill: "#3D4451"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.869 1.45604L240.14 28.7334",
    stroke: "#3D4451",
    strokeWidth: 2.91207,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.623 120.152L277.105 143.856",
    stroke: "#3D4451",
    strokeWidth: 2.91207,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.206 15.1428L219.737 34.4596",
    stroke: "#3D4451",
    strokeWidth: 2.91207,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.879 105.34L303.702 115.609",
    stroke: "#3D4451",
    strokeWidth: 2.91207,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.868 148.544L244.9 125.198",
    stroke: "#3D4451",
    strokeWidth: 2.91207,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.524 141.169L224.402 122.593",
    stroke: "#3D4451",
    strokeWidth: 2.91207,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.845 34.9449L280.502 18.8314",
    stroke: "#3D4451",
    strokeWidth: 2.91207,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.664 76.3934L178.677 82.2176C178.677 82.2176 175.959 83.5765 176.541 86.0033",
    stroke: "#3D4451",
    strokeWidth: 1.94138,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.556 50.1848L180.715 42.128",
    stroke: "#3D4451",
    strokeWidth: 2.91207,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7529_6275"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 484.502,
    height: 150,
    fill: "white",
    transform: "translate(0.749023)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGcpOnwork);
export default __webpack_public_path__ + "static/media/gcpOnwork.201e0da421ff00425982ce1406790762.svg";
export { ForwardRef as ReactComponent };